import React from 'react';
import { Badge, Button, Card, Col, Image, Row } from 'react-bootstrap';
import { Clock, Info, Heart } from 'lucide-react';
import Lait from '../../../../assets/images/diet/RR6.jpg';
import Baies from '../../../../assets/images/diet/RR36.jpg';
import { useNavigate } from 'react-router-dom';

const RecipeCard = ({ recipe }) => {
    const navigate = useNavigate();

    
    
    return (
      <>
    <React.Fragment>
            <Card  
                onClick={() => navigate('/diet-detail', { state: { recipe } })} 
                style={{ 
                    marginTop:"-1rem",
                    width: '100%',
                    height: '330px', 
                    border: '1px solid green',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)' 
                }}
            >
                <Card.Img 
                    variant="top" 
                    src={Baies}
                    alt="Döner végétarien"
                    style={{ 
                        borderRadius: '8px 8px 0 0',
                        height: '180px',
                        objectFit: 'cover'
                    }}
                />
                
                <Card.Body style={{ 
                    padding: '0.75rem',
                    height: '140px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <div style={{ 
                            color: '#FF9800', 
                            fontWeight: 'bold', 
                            fontSize: '0.8rem', 
                            marginBottom: '0.25rem' 
                        }}>
                            {recipe.category}
                        </div>
                        
                        <Card.Title style={{ 
                            fontWeight: 'bold', 
                            marginBottom: '0.5rem',
                            fontSize: '1rem',
                            lineHeight: '1.2',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {recipe.name}
                        </Card.Title>
                        
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '0.25rem' 
                        }}>
                            <Info size={14} style={{ marginRight: '0.5rem', color: '#757575' }} />
                            <span style={{ color: '#757575', fontSize: '0.8rem' }}>
                                {recipe.difficulty}
                            </span>
                        </div>
                        
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '0.25rem' 
                        }}>
                            <Clock size={14} style={{ marginRight: '0.5rem', color: '#757575' }} />
                            <span style={{ color: '#757575', fontSize: '0.8rem' }}>
                                {recipe.preparationTime}min
                            </span>
                        </div>
                    </div>
                    
                    <div>
                        <hr style={{ 
                            width: '90%', 
                            margin: '8px auto', 
                            borderTop: '1px solid green' 
                        }} />
                        
                        <div 
                            className='cursor-pointer' 
                            style={{ 
                                display: 'flex', 
                                justifyContent: 'flex-end', 
                                alignItems: 'center'
                            }}
                        >
                            <Heart size={16} style={{ marginRight: '0.3rem', color: '#757575' }} />
                            <span style={{ color: '#757575', fontSize: '0.8rem' }}>30</span>
                        </div>
                    </div>
                </Card.Body>
                
                <div style={{ position: 'absolute', bottom: '1rem', left: '1rem' }}>
                </div>
            </Card> 
        </React.Fragment>
     </>
        
    );
};

export default RecipeCard;